import React from 'react';
import PropTypes from 'prop-types';
import Icon from '@material-ui/core/Icon';

// Trilha de navegação simples: [{ label, onClick }] — o último item é o atual (sem link).
// Uso: <Breadcrumb items={[{ label: 'Funcionários', onClick: () => browserHistory.push(...) }, { label: nome }]} />
const Breadcrumb = ({ items }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 6,
      marginBottom: 12,
      fontSize: '0.9em',
      color: '#6b6b6b',
    }}
  >
    {items.map((item, index) => {
      const isLast = index === items.length - 1;
      return (
        <React.Fragment key={index}>
          {index > 0 && (
            <Icon style={{ fontSize: 16, color: '#b0b0b5' }}>chevron_right</Icon>
          )}
          {item.onClick && !isLast ? (
            <span
              onClick={item.onClick}
              style={{ cursor: 'pointer', color: '#2f6fa8' }}
            >
              {item.label}
            </span>
          ) : (
            <span style={{ color: isLast ? '#1a1a1a' : '#6b6b6b' }}>
              {item.label}
            </span>
          )}
        </React.Fragment>
      );
    })}
  </div>
);

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.node.isRequired,
      onClick: PropTypes.func,
    })
  ).isRequired,
};

export default Breadcrumb;
